<template>
  <div class="panelItem_content">
    <el-table
    v-if="isTemp != 1"
      size="mini"
      ref="Table"
      :data="tableData"
      class="Table"
      :highlight-current-row="true"
      :cell-style="{ borderColor: '#244447' }"
      :header-cell-style="{
        fontSize: '0.875rem',
        color: 'rgba(127, 132, 136, 1)',
        borderColor: '#244447',
        backgroundColor: 'rgba(180, 180, 180, .1)',
      }"
      :row-style="{
        fontSize: '0.875rem',
        color: '#B4B4B4',
        height: '3rem',
      }"
    >
      <el-table-column prop="position" label="设备" align="left">
        <template slot-scope="scope">
          <span @click="getA95Line(scope.row, true)" style="color: #44d7b6">
            {{ scope.row.position }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="max" label="最大值" align="left">
        <template slot-scope="scope">
          <span @click="torealTimeByEquip">{{ scope.row.max }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="average" label="平均值" align="left">
        <template slot-scope="scope">
          <span >{{ scope.row.average }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ninetyFive" label="参考值" align="left">
        <template slot-scope="scope">
          <span @click="getA95Line(scope.row, false)">{{
            scope.row.ninetyFive
          }}</span>
        </template>
      </el-table-column>
   
    </el-table>
    <el-table
    v-else
      size="mini"
      ref="Table"
      :data="tableData"
      class="Table"
      :highlight-current-row="true"
      :cell-style="{ borderColor: '#244447' }"
      :header-cell-style="{
        fontSize: '0.875rem',
        color: 'rgba(127, 132, 136, 1)',
        borderColor: '#244447',
        backgroundColor: 'rgba(180, 180, 180, .1)',
      }"
      :row-style="{
        fontSize: '0.875rem',
        color: '#B4B4B4',
        height: '3rem',
      }"
    >
      <el-table-column prop="position" label="设备" align="left">
        <template slot-scope="scope">
          <span @click="getA95Line(scope.row, true)" style="color: #44d7b6">
            {{ scope.row.position }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="max" label="最大值" align="left">
        <template slot-scope="scope">
          <span >{{ scope.row.max }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="avg" label="平均值" align="left">
        <template slot-scope="scope">
          <span >{{ scope.row.avg.toFixed(1) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="reference" label="参考值" align="left">
        <template slot-scope="scope">
          <span @click="getA95Line(scope.row, false)">{{
            scope.row.reference
          }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="温度设置" align="left">
        <template slot-scope="scope">
          <span @click="setTemp(scope.row,sensorList)" style="color:#44d7b6">设置</span>
        </template>
      </el-table-column>
    </el-table>
    <tempSetDialog ref="tempSetDialog" @getOneSensorHistory="getOneSensorHistory"></tempSetDialog>
  </div>
</template>

<script>
import { log } from "three";
import tempSetDialog from "./temp-set.vue";
export default {
  components: {tempSetDialog},
  props: {
    tableData: {
      type: Array,
    },
    flag: {
      type: "",
    },
    curElevator: {
      type: Object,
    },
    isTemp: {
      type: Number
    },
    sensorList:{
      type: Array,
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    getOneSensorHistory(){
      this.$emit("getOneSensorHistory");
    },
    setTemp(row,sensorList){
      console.log(row);
     this.$refs.tempSetDialog.form1.earlyWarningTemper = row.reference
     this.$refs.tempSetDialog.form1.warningReference = row.warningReference
      this.$refs.tempSetDialog.show()
    //  const a =  sensorList.find(item=>item.position == row.position)
     this.$refs.tempSetDialog.id = row.id

    },
    getA95Line(row, isSingle) {
      this.$emit("singleLine", this.flag, row.position, isSingle);
      if(this.$store.state.curposition == row.position){
        //同一个位置反复点击 单个曲线-》多个曲线-》单个曲线 要清空curposition
        this.$store.state.curposition = null
        return
      }

      this.$store.state.curposition = row.position;
      if (this.flag == 1) {
        this.$emit("getOneSensorHistory");
      }
      if (this.flag == 2) {
        this.$emit("getOneSensorHistory2");
      }
    },
    torealTimeByEquip() {
      this.$router.push({
        path: "/home/realTime",
        query: { id: this.$store.state.curElevatorInfo.id },
      });
    },
    test() {
      console.log(123);
      console.log(this.timeData);
      console.log(Object.keys(this.timeData));
      const key = Object.keys(this.timeData);
      const table = [];

      key.forEach((item) => {
        console.log(this.timeData[item]);
        table.push({
          name: this.formatterParamsName(item),
          value: this.timeData[item].value.toFixed(2),
          label: this.timeData[item].label,
          condition: this.timeData[item].condition,
        });
        console.log(table);
        this.tableData = table;
      });
    },
    formatterParamsName(name) {
      switch (name) {
        case "rms":
          return "平均dB(A)";
        case "std":
          return "模型识别得分";
        case "outliersNum":
          return "周期波峰数";
        case "kurtosis":
          return "峭度";
        case "anomalousBandNum":
          return "异常频段数";
        case "peakPeakValue":
          return "峰峰值";
        case "frequencyRatio":
          return "频率占比";
        // case "zeroCrossRate":
        //   return "过零率(%)";
      }
    },
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.panelItem_content {
  overflow: auto;
  margin-top: -10px;

  .echartCon {
    flex: 1;
    display: flex;
    align-items: center;
    height: 80%;
  }

  .topCon {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    img {
      margin-right: 2.375rem;
      width: 1.5rem;
      height: 1.5rem;
    }
  }
}

.item_span {
  color: black;
  font-size: medium;
}

.errortext {
  color: red;
  font-weight: bolder;
}
</style>


// WEBPACK FOOTER //
// src/components/historyTable.vue